import SlideNews from './SlideNews';
export default SlideNews;
